import { motion } from "framer-motion";
import { Heart, Loader2 } from "lucide-react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import FloatingCart from "@/components/layout/FloatingCart";
import FloatingWhatsApp from "@/components/layout/FloatingWhatsApp";
import ProductCard from "@/components/product/ProductCard";
import { useWishlist } from "@/context/WishlistContext";
import { useProducts } from "@/hooks/useProducts";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/context/LanguageContext";

const Wishlist = () => {
  const { wishlistIds, isLoading: wishlistLoading } = useWishlist();
  const { data: allProducts = [], isLoading: productsLoading } = useProducts();
  const { isAuthenticated } = useAuth();
  const { t } = useLanguage();

  const wishlistProducts = allProducts.filter((p) => wishlistIds.includes(p.id));
  const isLoading = wishlistLoading || productsLoading;

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <FloatingCart />
      <FloatingWhatsApp />

      <main className="pt-28 pb-20">
        <div className="container-luxury">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-12"
          >
            <span className="text-primary text-sm tracking-[0.3em] uppercase">{t.wishlist.badge}</span>
            <h1 className="text-4xl md:text-5xl font-serif mt-4 flex items-center justify-center gap-3">
              <Heart className="w-8 h-8 text-primary" />
              {t.wishlist.title}
            </h1>
          </motion.div>

          {!isAuthenticated ? (
            <div className="text-center py-20">
              <Heart className="w-16 h-16 text-muted-foreground/30 mx-auto mb-6" />
              <p className="text-muted-foreground text-lg mb-6">{t.wishlist.loginPrompt}</p>
              <Link to="/login">
                <Button variant="bronze" size="lg">{t.wishlist.signIn}</Button>
              </Link>
            </div>
          ) : isLoading ? (
            <div className="flex items-center justify-center py-20">
              <Loader2 className="w-8 h-8 animate-spin text-primary" />
            </div>
          ) : wishlistProducts.length === 0 ? (
            <div className="text-center py-20">
              <Heart className="w-16 h-16 text-muted-foreground/30 mx-auto mb-6" />
              <p className="text-muted-foreground text-lg mb-6">{t.wishlist.empty}</p>
              <Link to="/collection">
                <Button variant="bronze" size="lg">{t.wishlist.explore}</Button>
              </Link>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {wishlistProducts.map((product, index) => (
                <ProductCard key={product.id} product={product} index={index} />
              ))}
            </div>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Wishlist;
